
import './App.css';
import Header from './Header/Header';
import SubHead from './SubHead/SubHead';
import Delivery from './Delivery/Delivery';
// import Filter from './Components/Filters/Filter';
import TopBrands from './TopBrands/TopBrands';
import Restaurants from './Restaurants/Restaurants';
import {BrowserRouter as Router,Switch,Route,Link, Routes,useRoutes} from "react-router-dom";
import RestaurantCard from './Restaurants/RestaurantCard/RestaurantCard';
import { Fragment } from 'react';
import Searched from './Header/Searched/Searched';
import DeliveryTime from './Header/HeaderIcons/Del/DeliveryTime';
import Rating from './Header/HeaderIcons/Rating/Rating';
import Relevance from './Header/HeaderIcons/Relevance/Relevance';
import Cart from './Header/cart/Cart';
import Payment from '../CheckOut/Payment/Payment';
import SingleProduct from './Header/cart/SingleProduct/SingleProduct';
// import Context from '../Context';
// import {Provider} from "react-redux"
// import Store from "./utils/Store/Store"
const  App=()=> {
  return (
    <>
    
  
    <Router>
    <Header/>
    <Routes>
      <Route exact path="/" element={<div><TopBrands/><Restaurants/></div>}/>
      <Route exact path="/rcard/:id" element={<RestaurantCard/>}/>
      <Route exact path="/searched/:id" element={<Searched/>}/>
      <Route exact path="/choice/:Head" element={<DeliveryTime/>}/>
      <Route exact path="/choice/:Head" element={<Rating/>}/>
      <Route exact path="/choice/:Head" element={<Relevance/>}/>
      <Route exact path="/cart" element={<Cart/>}/>
      <Route exact path="/payment" element={<Payment/>}/>
      {/* <Route exact path="/single/:id" element={<SingleProduct/>}/> */}
    </Routes>
    </Router>
   
    
    </>
  );
}


export default App;
// <SubHead/>
